module.exports = global["I18n"] = require("-!./i18n.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/i18n-js/app/assets/javascripts/i18n.js
// module id = BiMo
// module chunks = 25